export const getPercent = (value: number, total: number) =>
  Math.round((value / 100) * total);
